import { taxpayerCertificatesApi } from '../../api';

const TaxpayerCertificateService = {
    /**
     * 📥 Subir un archivo de firma electrónica (certificado o clave).
     * POST /api/electronic-signature/files
     */
    uploadFile: async (file: File, fileType: 'CERTIFICATE' | 'PRIVATE_KEY') => {
        const response = await taxpayerCertificatesApi.postFormData({ fileType }, file);
        return response.data;
    },

    /**
     * 📝 Actualizar un archivo de firma electrónica existente.
     * PUT /api/electronic-signature/files/{fileType}
     */
    updateFile: async (file: File, fileType: 'CERTIFICATE' | 'PRIVATE_KEY') => {
        // console.log(file, fileType)
        
        const response = await taxpayerCertificatesApi.putFormDataByPath(
            fileType, // será usado como parte del path: /api/electronic-signature/files/{fileType}
            {},       // no hay datos adicionales
            file      // el nuevo archivo
        );
        return response.data;
    },

    /**
     * 🗑 Eliminar un archivo por tipo.
     * DELETE /api/electronic-signature/files/{fileType}
     */
    deleteFile: async (fileType: 'CERTIFICATE' | 'PRIVATE_KEY') => {
        const response = await taxpayerCertificatesApi.removeCustom(`/${fileType}`);
        return response.data;
    },

    /**
     * 📄 Obtener todos los archivos de firma electrónica cargados.
     * GET /api/electronic-signature/files
     */
    getAllFiles: async () => {
        const response = await taxpayerCertificatesApi.fetchAll();
        return response.data;
    },
};

export default TaxpayerCertificateService;
